import { forwardRef, type HTMLAttributes } from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../lib/utils';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium transition-colors',
  {
    variants: {
      variant: {
        primary: 'bg-primary-100 text-primary-700',
        success: 'bg-success-100 text-success-700',
        danger: 'bg-danger-100 text-danger-700',
        warning: 'bg-warning-100 text-warning-700',
        neutral: 'bg-neutral-100 text-neutral-700',
        info: 'bg-blue-100 text-blue-700',
        // Market types
        food: 'bg-success-100 text-success-700',
        nonfood: 'bg-primary-100 text-primary-700',
        maintenance: 'bg-warning-100 text-warning-700',
      },
    },
    defaultVariants: {
      variant: 'neutral',
    },
  }
);

export interface BadgeProps
  extends HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof badgeVariants> {}

const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ className, variant, ...props }, ref) => {
    return (
      <span
        className={cn(badgeVariants({ variant, className }))}
        ref={ref}
        {...props}
      />
    );
  }
);

Badge.displayName = 'Badge';

export { Badge, badgeVariants };
